// extracted by mini-css-extract-plugin
export default {"component":"PayoutPage_component__b41Xr","horizontal":"PayoutPage_horizontal__dOJsd","vertical":"PayoutPage_vertical__YLeTT","field":"PayoutPage_field__7WmWm"};